var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderMypageBlack = function SvgHeaderMypageBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M12.004 11.25a4.88 4.88 0 0 1-4.875-4.875A4.88 4.88 0 0 1 12.004 1.5a4.88 4.88 0 0 1 4.875 4.875 4.88 4.88 0 0 1-4.875 4.875m0-8.25a3.38 3.38 0 0 0-3.375 3.375 3.38 3.38 0 0 0 3.375 3.375 3.38 3.38 0 0 0 3.375-3.375A3.38 3.38 0 0 0 12.004 3m9.746 19.5H5.25c-1.654 0-3-1.346-3-3v-6.75h19.5zm-18-8.25v5.25c0 .827.673 1.5 1.5 1.5h15v-6.75z",
    clipRule: "evenodd"
  })));
};
export default SvgHeaderMypageBlack;